@import '../../utils/global.module.less';

.itemIdTitle {
    font-family: Hanken Grotesk;
    font-weight: 550;
}

.itemIdText {
    .itemIdTitle();
    margin-right: 20px;
}

.source_module {
    .itemIdTitle();
    color: #71747a;
    font-size: 12px;
}

.blackLineSeperator {
    background-color: black;
    width: 2px;
    min-width: 2px;
    margin: 0px 10px;
}

.entryContainer {
    width: 100%;
    max-width: 100%;
    // &:not([data-indent='0']) {
    //     padding-top: 14px;
    // }

    padding-top: 14px;
    padding-bottom: 14px;
    border-bottom: 1px solid #b8bcc6;
}

.actionIcons {
    display: flex;
    margin-top: 7px;
}

.svgActionIcon {
    width: 14px;
    height: 14px;
    cursor: pointer;
    opacity: 0.25;
    transition: opacity 0.5s ease-in-out;
    &:hover {
        .filterBlue();
        opacity: 1;
        animation: scaleInOut 0.75s ease-in-out;
    }
    &:active {
        opacity: 1;
        .filterDarkBlue();
    }
    margin: 0px 4px;
}
.deleteFact {
    background-color: rgb(212, 206, 206);
    padding: 2px 6px;
    margin-left: 10px;
    border: 10px;
    border-radius: 20px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    &:hover {
        background-color: rgb(239, 147, 147);
        transform: scale(1.2);
        cursor: pointer;
    }

    .small-shadow();
}
